// What keeps a template body's variables (its {{n}} numbers, sorted) from Meta's review: a number
// skipped or not starting at 1 (ORDER), or one left without the example the reviewer reads (EXAMPLE).
export const bodyVariablesError = (variables, examples) => {
  if (variables.some((variable, index) => variable !== String(index + 1))) {
    return 'ORDER';
  }
  if (variables.some(variable => !(examples[variable] || '').trim())) {
    return 'EXAMPLE';
  }
  return '';
};
